import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class MaintenanceContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 0, 
        }
        

    }
 
 

    render()
    { 

        const projects = JSON.parse(localStorage.getItem("maintenances"));
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>

            <div class="section-full p-t80 p-b50">
                <div class="container">
                   
                    <div class="section-content m-b80">
                    	<div class="p-b30">
                            <h2 class="text-uppercase">Maintenance Services </h2>
                            <div class="wt-separator-outer">
                                <div class="wt-separator style-square">
                                    <span class="separator-left site-bg-primary"></span>
                                    <span class="separator-right site-bg-primary"></span>
                                </div>
                            </div>
                        </div>
                        <div id="no-more-tables">
                        	 <table class="table table-striped table-bordered table-condensed cf wt-responsive-table">
                                <thead class="cf">
									 
                                    <tr class="table-warning">
                                        <th>Sr. No.</th>
                                        <th class="numeric">Scope of Work</th>
                                        <th class="numeric">Location</th>
                                        <th class="numeric">Client</th> 
                                    </tr>
								
                                </thead>
                                <tbody>
                                     {projects.map((item, index) => (
                                    <tr>
                                        <td data-title="Code">{index+1}</td>
                                        <td data-title="Company">{item.scope}</td>
                                        <td data-title="Price" class="numeric">{item.location}</td>
                                        <td data-title="Change" class="numeric">{item.client}</td> 
                                        
                                        
                                    </tr> 
                                     ))}
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                                                    

					
                    
                    
                </div>
            </div>
   
        </div>
       

    );
 
    }
}

export default MaintenanceContent;